(function(app) {

    app.provider("subUserApi",
    [
        function() {
            this.$get = [
                "crmApiGateway", function(crmApiGateway) {
                    var service = {};

                    service.get = function(subUserId) {
                        return crmApiGateway.get("/SubUsers/" + subUserId);
                    };

                    service.getChildren = function(userId) {
                        return crmApiGateway.getArray("/Users/" + userId + "/Children");
                    };

                    service.getParents = function(userId) {
                        return crmApiGateway.getArray("/Users/" + userId + "/Parents");
                    };

                    service.create = function(model) {
                        return crmApiGateway.post("/SubUsers", model);
                    };

                    service.delete = function(subUserId) {
                        return crmApiGateway.delete("/SubUsers/" + subUserId);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line